import React, { Component } from 'react';

import{FormattedDate} from "react-intl";
import{FormattedTime} from "react-intl";

class DetalhesEvento extends Component {

    constructor(props) {
        super(props);
    
        this.state = {
          modalIsOpen: false,
          newStartDate: new Date(),
          newEndDate: new Date(),
          newInsertionDate: new Date()
        };
    
    }

    componentWillReceiveProps(nextProps) {
        
        if(nextProps.evento.startDate !== null){      
          this.setState({newStartDate: nextProps.evento.startDate});
        } else{
          this.setState({newStartDate: ""});
        }
    
        if(nextProps.evento.endDate !== null){  
          this.setState({newEndDate: nextProps.evento.endDate});
        } else{
          this.setState({newEndDate: ""});
        }
    
        if(nextProps.evento.startTime !== null){
          this.setState({newStartTime: nextProps.evento.startTime});
        } else{
          this.setState({newStartTime: ""});
        }
    
        if(nextProps.evento.endTime !== null){
          this.setState({newEndTime: nextProps.evento.endTime});
        } else{
          this.setState({newEndTime: ""});
        }
    
        if(nextProps.evento.insertionDate !== null){
          this.setState({newInsertionDate: nextProps.evento.insertionDate});
        } else{
          this.setState({newEndTime: ""});
        }

        if(nextProps.evento.limitEnrollmentDate !== null){
            this.setState({newLimitEnrollmentDate: nextProps.evento.limitEnrollmentDate});
          } else{
            this.setState({newLimitEnrollmentDate: ""});
          }
    
        if(nextProps.evento.permiteInscricao){
          const available = parseInt(nextProps.evento.maxParticipants) - parseInt(nextProps.evento.currentParticipants);
          this.setState({availableParticipants: available});
        }
        
    }



    render() {
        return (

            <div>
            {this.props.evento !== undefined && this.props.evento.title !== "" && 
            <React.Fragment>
            <p className="labels">Foto Principal</p>
            <img
              className="backoffice-foto-principal"
              src={this.props.evento.mainPhoto}
              alt="Foto Principal"
            />

            
            <p className="labels">Título</p>
            <p className="details">{this.props.evento.title}</p>

            <p className="labels">Descrição</p>
            <p className="details" dangerouslySetInnerHTML={{__html: this.props.evento.description}}></p>

            <p className="labels">Identificador</p>
            <p className="details">{this.props.evento.identifier}</p>

            <p className="labels">Local</p>
            <p className="details">{this.props.evento.location}</p>

            <div className="row">
                <div className="col-3">
                    <p className="labels">Data de início</p>
                    <p className="details">
                        <FormattedDate
                            value={new Date(this.state.newStartDate)}
                            year='numeric'
                            month='long'
                            day='2-digit'
                        />
                    </p>
                </div>
                <div className="col-3">
                    <p className="labels">Hora de início</p>
                    <p className="details">
                    
                    {
                    (this.state.newStartTime !== undefined && this.state.newStartTime !== "") ?
                        <FormattedTime value={this.state.newStartTime} />
                        :
                        "Não está definida"
                    }
                        
                    </p>
                </div>
                <div className="col-3">
                    <p className="labels">Data de fim</p>
                    <p className="details">
                    {
                  (this.state.newEndDate !== undefined && this.state.newEndDate !== "") ?

                    <span>
                    <FormattedDate
                      value={this.state.newEndDate}
                      year='numeric'
                      month='long'
                      day='2-digit'
                    />
                    </span>
                    :
                    "Não está definida"
                    }
                        
                    </p>
                </div>
                <div className="col-3">
                    <p className="labels">Hora de fim</p>
                    <p className="details">
                        
                    {
                    (this.state.newEndTime !== undefined && this.state.newEndTime !== "") ?
                        <FormattedTime value={this.state.newStartTime} />
                        :
                        "Não está definida"
                    }
                        
                    </p>
                </div>
            </div>
            

            <p className="labels">Permite Inscrição</p>
            <p className="details">{this.props.evento.permiteInscricao === true ? "Sim" : "Não"}</p>

            {
                this.props.evento.permiteInscricao &&

                <React.Fragment>
                  <div className="row">
                    <div className="col-3 col-sm-6">
                      <p className="labels">Preço por adulto</p>
                      <p className="details">{this.props.evento.price}</p>
                    </div>
                    <div className="col-3 col-sm-6">
                      <p className="labels">Preço por criança</p>
                      <p className="details">{this.props.evento.childPrice}</p>
                    </div>
                    <div className="col-3 col-sm-6">
                      <p className="labels">Inscritos</p>
                      <p className="details">{this.props.evento.currentParticipants}</p>
                    </div>
                    <div className="col-3 col-sm-6">
                      <p className="labels">Limite de pessoas</p>
                      <p className="details">{this.props.evento.maxParticipants}</p>
                    </div>
                    <div className="col-3 col-sm-6">
                      <p className="labels">Data limite de inscrição</p>
                      <p className="details">
                          {this.props.evento.limitEnrollmentDate !== undefined && this.props.evento.limitEnrollmentDate !== "" ? 
                              <FormattedDate
                              value={new Date(this.props.evento.limitEnrollmentDate)}
                              year='numeric'
                              month='long'
                              day='2-digit'
                          />
                          :

                          "Não está definida"
                      }
                      </p>
                    </div>
                  </div>

                </React.Fragment>
            }

            

            {this.props.evento.photos !== undefined && this.props.evento.photos.length !== 0 && 
              <p className="labels">Outras Fotografias</p>
            }
            <div className="row">
              {this.props.evento.photos &&
                this.props.evento.photos.map(function(url) {
                  return (
                    <div key={url} className="flex-image">
                      <img src={url} alt="Foto Notícia" />
                    </div>
                  );
                })}
            </div>
            
            <p className="labels">Data de inserção</p>
            <p className="details">
                
                <FormattedDate
                    value={new Date(this.props.evento.insertionDate)}
                    year='numeric'
                    month='long'
                    day='2-digit'
                />
                
            </p>
            </React.Fragment>
        }
          </div>
        
        );
    }
}

export default DetalhesEvento;